import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/testimonials';
export function TestimonialsSection() {
  return <section className="bg-brand-alt px-4 py-20 sm:py-24" data-id="element-158" data-mp="1mz90r7l5lwc9">
      <Reveal className="mx-auto max-w-6xl" data-id="element-159" data-mp="1r1dsg0s1kiw9">
        <SectionHeading eyebrow="Testimonios" title={<>
              Lo que dicen los{' '}
              <span className="italic text-brand-terra" data-id="element-161" data-mp="1d47dyiecp6cu">
                docentes argentinos.
              </span>
            </>} data-id="element-160" data-mp="1r02skc1pvvaf" />
        <div className="mt-6 flex flex-wrap items-center justify-center gap-2.5" data-id="element-162" data-mp="1427w5nvihy8u">
          <span className="flex items-center gap-1" aria-label="Calificación promedio 4,9 de 5" data-id="element-163" data-mp="181zwjdar4y34">
            {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-4 w-4 fill-brand-gold text-brand-gold" aria-hidden="true" data-id="element-164" data-mp="32gizti34b5m7" />)}
          </span>
          <span className="text-xs font-semibold text-brand-navy sm:text-sm" data-id="element-165" data-mp="2q2rbyp4ls6sf">
            4.9/5
          </span>
          <span className="text-brand-line" aria-hidden="true" data-id="element-166" data-mp="34rx8u6fyxkx5">
            |
          </span>
          <span className="text-xs text-brand-gray sm:text-sm" data-id="element-167" data-mp="2zrre2heejiau">
            +2.000 Profesores
          </span>
        </div>

        <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-168" data-mp="2c3rr7sk7oc1j">
          {testimonials.map(testimonial => <article key={testimonial.name} className="flex h-full flex-col rounded-2xl border border-brand-line bg-brand-cream p-7" data-id="element-169" data-mp="275gf1b6g1pg5">
              <div className="flex gap-1" aria-label="5 de 5 estrellas" data-id="element-170" data-mp="2h0ry25ovxitp">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-brand-gold text-brand-gold" aria-hidden="true" data-id="element-171" data-mp="18u9ki96hb33" />)}
              </div>
              <blockquote className="mt-5 flex-1 font-display text-[15px] leading-relaxed text-brand-text sm:text-base" data-id="element-172" data-mp="8dvbqhzvhddy">
                “{testimonial.quote}”
              </blockquote>
              <footer className="mt-auto pt-6" data-id="element-173" data-mp="db3ykvvyu5lj">
                <p className="text-sm font-semibold text-brand-navy" data-id="element-174" data-mp="ib03cxchm125">
                  {testimonial.name}
                </p>
                <p className="mt-0.5 text-xs text-brand-gray" data-id="element-175" data-mp="3gvi36obunv8t">
                  {testimonial.location}{' '}
                  <span aria-hidden="true" data-id="element-176" data-mp="3lqnmrghs4xtq">{testimonial.flag}</span>
                </p>
              </footer>
            </article>)}
        </div>
      </Reveal>
    </section>;
}